import { render, staticRenderFns } from "./downloadHistory.vue?vue&type=template&id=2585d15c&"
import script from "./downloadHistory.vue?vue&type=script&lang=js&"
export * from "./downloadHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports